import { Routes } from '@angular/router';
import { policyRoutes } from './policy.routes';

export const protectedRoutes: Routes = [
    {
        path: 'documents',
        loadChildren: () =>
            import('../pages/documents/documents.routes').then(m => m.DOCUMENTS_ROUTES),
    },
    ...policyRoutes,
    { path: '**', redirectTo: '/documents' },
];
